/**
 * Create Data Bins context for custom hook
 */

import { createContext } from 'react'

const DataBinsContext = createContext({
  fetchDataBinsBySlugName: () => {},
  updateDataBinsBySlugName: () => {}
})

export default DataBinsContext
